'use client';

import { CenteredContainer } from '@ianesthesie-kit/core';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export const SplashScreenLoader = () => (
  <CenteredContainer
    bgcolor="background.default"
    position="fixed"
    zIndex={999999}
    top={0}
    left={0}
    width="100%"
    sx={{
      height: '100vh'
    }}
  >
    <Box position="relative" bottom={40}>
      <CircularProgress size={48} variant="indeterminate" />
    </Box>
  </CenteredContainer>
);
